import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';

/**
 * Configuração de colunas visíveis (persistida em localStorage).
 * Ordem das colunas continua sendo ajustada arrastando no DataTable.
 */
export default function ColumnConfigDialog({
  visible,
  onHide,
  storageKey,
  colunasDisponiveis = [],
  colunasVisiveis,
  onSave,
}) {
  const [selected, setSelected] = useState(new Set());
  const [resetOrderOnSave, setResetOrderOnSave] = useState(false);

  const disponiveis = (colunasDisponiveis || []).filter((c) => c?.field);

  useEffect(() => {
    if (!visible) return;
    setResetOrderOnSave(false);
    const fields =
      colunasVisiveis?.length > 0
        ? colunasVisiveis
        : disponiveis.filter((c) => c.defaultVisible !== false).map((c) => c.field);
    const next = new Set(fields);
    disponiveis.forEach((c) => {
      if (c.alwaysVisible) next.add(c.field);
    });
    setSelected(next);
  }, [visible, colunasDisponiveis, colunasVisiveis]);

  const toggle = (col) => {
    if (col.alwaysVisible) return;
    const field = col.field;
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(field)) {
        if (next.size <= 1) return prev;
        next.delete(field);
      } else {
        next.add(field);
      }
      return next;
    });
  };

  const salvar = () => {
    const fields = disponiveis.map((c) => c.field).filter((f) => selected.has(f));
    if (storageKey) {
      try {
        localStorage.setItem(`nfse-grid-cols:${storageKey}`, JSON.stringify(fields));
        if (resetOrderOnSave) {
          localStorage.removeItem(`nfse-grid-order:${storageKey}`);
        }
      } catch {
        // ignore
      }
    }
    onSave?.(fields, { resetOrder: resetOrderOnSave });
    onHide?.();
  };

  const restaurarPadrao = () => {
    const defaults = disponiveis
      .filter((c) => c.defaultVisible !== false || c.alwaysVisible)
      .map((c) => c.field);
    setSelected(new Set(defaults.length ? defaults : disponiveis.map((c) => c.field)));
    setResetOrderOnSave(true);
  };

  return (
    <Dialog
      header="Configurar colunas"
      visible={visible}
      onHide={onHide}
      style={{ width: '520px' }}
      breakpoints={{ '600px': '95vw' }}
      modal
      contentStyle={{ overflow: 'auto', maxHeight: '60vh' }}
      footer={
        <div className="cadastro-grid-dialog-footer">
          <Button label="Restaurar padrão" className="p-button-text" onClick={restaurarPadrao} />
          <Button label="Cancelar" className="p-button-text" onClick={onHide} />
          <Button label="Salvar" icon="pi pi-check" onClick={salvar} />
        </div>
      }
    >
      <p className="cadastro-grid-dialog-hint">
        Marque os campos que deseja exibir ({disponiveis.length} disponíveis). Arraste os cabeçalhos
        na tabela para alterar a ordem.
      </p>
      {!disponiveis.length ? (
        <p style={{ color: '#b91c1c' }}>Nenhuma coluna disponível para configurar.</p>
      ) : (
        <div className="cadastro-grid-cols-list">
          {disponiveis.map((col) => (
            <div key={col.field} className="cadastro-grid-cols-item">
              <Checkbox
                inputId={`col-cfg-${storageKey || 'grid'}-${col.field}`}
                checked={selected.has(col.field)}
                disabled={!!col.alwaysVisible}
                onChange={() => toggle(col)}
              />
              <label htmlFor={`col-cfg-${storageKey || 'grid'}-${col.field}`}>
                {col.header || col.field}
                {col.alwaysVisible ? ' (fixa)' : ''}
              </label>
            </div>
          ))}
        </div>
      )}
    </Dialog>
  );
}
